var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAiIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4084 5.73448L15.0534 4.30562L16.4823 3.66058C16.8007 3.51361 16.8007 3.06454 16.4823 2.91757L15.0534 2.27254L14.4084 0.835505C14.2614 0.517071 13.8124 0.517071 13.6654 0.835505L13.0204 2.26437L11.5833 2.90941C11.2649 3.05638 11.2649 3.50545 11.5833 3.65242L13.0122 4.29745L13.6572 5.73448C13.8042 6.05292 14.2614 6.05292 14.4084 5.73448ZM7.90908 6.95923L6.61085 4.10149C6.32508 3.46462 5.4106 3.46462 5.12483 4.10149L3.8266 6.95923L0.968861 8.25746C0.331994 8.5514 0.331994 9.45771 0.968861 9.74348L3.8266 11.0417L5.12483 13.8994C5.41877 14.5363 6.32508 14.5363 6.61085 13.8994L7.90908 11.0417L10.7668 9.74348C11.4037 9.44954 11.4037 8.54323 10.7668 8.25746L7.90908 6.95923ZM13.6572 12.2665L13.0122 13.6953L11.5833 14.3404C11.2649 14.4873 11.2649 14.9364 11.5833 15.0834L13.0122 15.7284L13.6572 17.1654C13.8042 17.4839 14.2533 17.4839 14.4002 17.1654L15.0453 15.7366L16.4823 15.0915C16.8007 14.9446 16.8007 14.4955 16.4823 14.3485L15.0534 13.7035L14.4084 12.2665C14.2614 11.948 13.8042 11.948 13.6572 12.2665Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiIcon);
export default __webpack_public_path__ + "static/media/ai_icon.29f9e7ec.svg";
export { ForwardRef as ReactComponent };